'use client';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import { Button } from '@eliadmin/core/src/components/ui/button';
import { HtmlDescription } from './shared/html-description';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';

export function SubscriptionBanner({
  title,
  description,
  price,
  image,
}: {
  title: string;
  description: string;
  price: string;
  image: string;
}) {
  const { me } = useCustomerStore();
  if (!me || (me && me?.customer?.customer_type?.type !== 'company')) {
    return (
      <section className={cn('custom-section', 'py-16 sm:py-20 lg:gap-24')}>
        <div
          className={cn(
            'custom-container',
            'relative z-[5] flex max-w-[640px] flex-col items-center justify-center gap-8',
          )}
        >
          <h2 className="text-center text-2xl font-bold text-foreground sm:text-3xl">
            Získajte neobmedzený prístup k videoživotopisom
          </h2>
          <HtmlDescription
            content={'A prvé spoznávacie kolo pohovorov budete mať za sebou.'}
            color="foreground"
            size="md"
            className="text-center"
          />
          <p className="text-2xl font-normal text-foreground sm:text-3xl">
            <strong>70,00€&nbsp;&nbsp;/</strong>&nbsp;&nbsp;mesačne
          </p>
          <Button asChild className="w-full sm:w-fit">
            <Link prefetchOnHover href={'/cennik'}>
              Aktivovať predplatné
            </Link>
          </Button>
        </div>
        <div className="absolute inset-0 z-[0] h-full w-full bg-[#F3F3F3]" />
        <Image
          src={image}
          alt={title}
          fill
          style={{ objectFit: 'cover', objectPosition: 'center' }}
          className="absolute inset-0 z-[1] h-full w-full opacity-20"
        />
      </section>
    );
  } else {
    return null;
  }
}
